module.exports = __webpack_public_path__ + "img/erweima.a6c1511c.png";